import getters from '@codehq/aurora-app-core/src/store/modules/auth/getters';

const customGetters = {
  tokenRemaining: (state) => {
    const date1 = new Date(state.token_expires);
    const date2 = new Date();
    return Math.abs(date2 - date1);
  },
};

export default { ...getters, ...customGetters };
